<div class="ml-3">
  <div class="text-lg">
    Campaign Trackers
</div>

  <div class="flex justify-content-between mt-6 pr-4">
      <div class="flex flex-row gap-3">
        <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
        ></creditor-autocomplete>

        <p-button (click)="search()" styleClass="text-xs" label="Get" icon="pi pi-search text-xs" [outlined]="true" severity="secondary"></p-button>   
      </div>

      
  </div>
  <div class="mt-4">
      <p-table [value]="campaignTrackers" 
               [paginator]="false"
               [tableStyle]="{ 'min-width': '50rem' }"
      >

          <ng-template pTemplate="header">
              <tr class="text-xs">
                  <th>Campaign Tracker Id</th>
                  <th>Name</th>
                  <th>Email Comms</th>
                  <th>SMS Comms</th>  
                  <th>Communication Channels</th>   
                  <th>Day</th>              
                  <th>Recipient Count</th>   
                  <th>Rejected Mobile Message Count</th> 
                  <th>Rejected Email Count</th>        
                  <th>Created On</th>                 
                  <th>Campaign Start Time</th>          
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tracker>
              <tr class="text-xs">
                  <td>{{ tracker.campaignTrackerId }}</td>
                  <td>{{ tracker.name }}</td>
                  <td>{{ tracker.emailCommsPlatformId }}</td>
                  <td>{{ tracker.smsCommsPlatformId }}</td>  
                  <td>{{ tracker.communicationChannels }}</td>  
                  <td>{{ tracker.daysFromStart }}</td>      
                  <td>{{ tracker.recipientCount }}</td>   
                  <td>{{ tracker.rejectedMobileMessageCount || 0 }}</td>  
                  <td>{{ tracker.rejectedEmailCount || 0 }}</td>  
                  <td>{{ tracker.createdOnUtc | date : 'MMMM d, y'  }}</td> 
                  <td>{{ tracker.campaignStartTimeUtc | date : 'h:mma'  }}</td>        
                 
              </tr>
          </ng-template>
      </p-table>

      <p-paginator 
        styleClass="mt-3"
        (onPageChange)="onPageChange($event)" 
        [rows]="rows" 
        [totalRecords]="totalRecords" 
        [rowsPerPageOptions]="[10, 30, 50]" />

  </div>

</div>